import React from "react";
import { Link } from "react-router-dom";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Card from "../../../components/cards/Card";
import { FunnelChart } from "../../../components/charts/Crm/FunnelChart";
//mock data
import { ads } from "../Mock";
import { formatCurrency } from "../../../utils/formatCurrency";
import BarChartAdsOrigins from "../../../components/charts/Crm/BarChartAdsOrigins";
import BarChartSalesImob from "../../../components/charts/Crm/BarChartSalesImob";
import ColumnChartImobServices from "../../../components/charts/Crm/ColumnChartImobServices";
import ColumnChartBrokerServices from "../../../components/charts/Crm/ColumnChartBrokerServices";

const AdsDashboard = () => {
  const items = [
    {
      template: () => (
        <Link to={"/crm/ads/dashboard"} className="p-breadcrumb-link">
          Dashboard de Anúncios
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const rankedAds = ads
    .filter((ad) => ad.effective_status === "ACTIVE")
    .sort((a, b) => b.return - a.return)
    .slice(0, 5);

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
      </div>

      <div className="row">
        <Card
          title="Gastos"
          value={formatCurrency(1)}
          size="col-xl-3 col-md-12"
          desc="Total gasto com anúncios"
          class={"widget widget-stats bg-red pb-0 mb-2"}
          icon={<i className="fa-solid fa-hand-holding-dollar"></i>}
        />
        <Card
          title="Conversão"
          value={formatCurrency(1)}
          size="col-xl-3 col-md-12"
          desc="Total de conversão"
          class="widget widget-stats bg-green pb-0 mb-2"
          icon={<i className="fa fa-dollar-sign fa-fw"></i>}
        />
        <Card
          title="Lucro / Prejuízo"
          value={formatCurrency(1)}
          size="col-xl-3 col-md-12"
          desc="Conversão - Gastos"
          class={"widget widget-stats bg-black bg-opacity-75 pb-0 mb-2"}
          icon={<i className="fa-solid fa-balance-scale"></i>}
        />
        <Card
          title="N° anúncios ativos"
          value={1}
          size="col-xl-3 col-md-12"
          desc="Total anúncios ativos"
          class={"widget widget-stats bg-primary pb-0 mb-2"}
          icon={<i className="fa-solid fa-check"></i>}
        />
      </div>

      <div className="row p-3 mx-0 mt-2 bg-white rounded">
        <div className="col-xl-6 my-2">
          <h4 className="mb-3">Acertividade do Funil</h4>
          <FunnelChart />
        </div>
        <div className="col-xl-6 my-2">
          <h4>Rank dos Anúncios que Mais Converteram</h4>
          <div className="table-responsive-ads-ranking">
            <table className="table-ads-ranking table-striped-ads-ranking text-center-ads-ranking">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Imagem</th>
                  <th>Nome</th>
                  <th>Custo</th>
                  <th>Retorno</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rankedAds.map((ad, index) => (
                  <tr key={ad.id} className="table-row-ads-ranking">
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={ad.media.thumbnail_url || ad.media.image_url}
                        alt={ad.name}
                        className="table-img-ads-ranking"
                      />
                    </td>
                    <td>{ad.name}</td>
                    <td>{formatCurrency(ad.spend)}</td>
                    <td>{formatCurrency(ad.return ?? 0)}</td>
                    <td>
                      {ad.effective_status === "ACTIVE" ? (
                        <span className="badge bg-success">Ativo</span>
                      ) : (
                        <span className="badge bg-danger">Pausado</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      <div className="row p-3 mx-0 mt-3 bg-white rounded">
        <div className="col-xl-3 my-2">
          <h4>Origens</h4>
          <BarChartAdsOrigins />
        </div>
        <div className="col-xl-3 my-2">
          <h4>Vendas por imob</h4>
          <BarChartSalesImob />
        </div>
        <div className="col-xl-6 my-2">
          <h4>Atendimentos por imob</h4>
          <ColumnChartImobServices />
        </div>
      </div>
      <div className="row p-3 mx-0 mt-3 bg-white rounded">
        <div className="col-xl-12 my-2">
          <h4>Atendimentos por corretor</h4>
          <ColumnChartBrokerServices />
        </div>
      </div>
    </>
  );
};

export default AdsDashboard;
